/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./time-log-update-description-action-body').TimeLogUpdateDescriptionActionBody} TimeLogUpdateDescriptionActionBody
 */

/**
 * @typedef {import('./time-log-update-description-action-response').TimeLogUpdateDescriptionActionResponse} TimeLogUpdateDescriptionActionResponse
 */

/**
 * The path of the TimeLogUpdateDescriptionAction action.
 */
export const timeLogUpdateDescriptionActionPath = new SweetPath('/api/time_log/update_description/{time_log_id}', {
  path: '{param}',
});

/**
 * Creates a contextualized TimeLogUpdateDescriptionAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createTimeLogUpdateDescriptionAction(axios) {
  /**
   * The timeLogUpdateDescriptionAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: TimeLogUpdateDescriptionActionBody } }
   *
   * @returns {Promise<TimeLogUpdateDescriptionActionResponse>}
   */
  function timeLogUpdateDescriptionAction({ headers = {}, parameters = {}, body } = {}) {
    const path = timeLogUpdateDescriptionActionPath.insert(parameters);

    return axios.put(path, body, { headers });
  }

  return timeLogUpdateDescriptionAction;
}
